<div class="background">
  <p-card class="container login-card">
    <ng-template pTemplate="header">
      <div class="header-content">
        <img src="../../assets/images/bgs-logo.png" alt="Logo" class="logo-img" />
        <h1 class="custom-title p-m-1">Garden Joy</h1>
        <h2 class="custom-subtitle p-m-1">Flora CMS</h2>
        <small class="p-m-1"><strong>Environment:</strong> {{domainEnv}}</small>
      </div>
    </ng-template>
    <div class="p-fluid login-card-body">
      <div class="login-primary-actions">
        <asl-google-signin-button *ngIf="!loggedIn && !isGuestUser" type='standard' size='large' shape='pill' theme='filled_blue'
          logo_alignment='center'>
        </asl-google-signin-button>
        <p-card *ngIf="loggedIn && !isGuestUser" header="{{'Welcome!'}}" subheader="{{user.name}}" [style]="{width: '250px'}"
          styleClass="p-card-shadow">
          <ng-template pTemplate="header" *ngIf="user && loggedIn">
            <img *ngIf="loggedIn" src="{{ user.photoUrl.replace('s96-c','s500-c') }}" referrerpolicy="no-referrer"
              [style]="{objectFit: 'cover', 'border-radius': '10px', height: '200px'}">
          </ng-template>
          <small *ngIf="user && loggedIn">{{ user.email }}</small>
        </p-card>
        <p-button *ngIf="loggedIn && !isGuestUser" label="Logout from Google" icon="pi pi-sign-out" (click)="logout()"
          styleClass="p-button-secondary logout-button"></p-button>
        <p-button *ngIf="loggedIn && isGuestUser" label="Logout from Test CMS" icon="pi pi-sign-out" (click)="logout()"
          styleClass="p-button-secondary logout-button"></p-button>
      </div>

      <div *ngIf="!loggedIn" class="external-auth-section">
        <p-divider align="center">
          <span>OR</span>
        </p-divider>
        <p-divider align="center" class="p-mt-3">
          <span class="p-tag p-tag-info external-users-tag">External Users</span>
        </p-divider>
        <div class="external-auth-actions">
          <p-button label="Login" icon="fa-solid fa-right-to-bracket" styleClass="p-button-secondary external-auth-button"
            (click)="displayExternalLogin = true"></p-button>
          <p-button label="Register" icon="fa-solid fa-user-plus" styleClass="p-button-secondary external-auth-button"
            (click)="displayExternalRegister = true"></p-button>
        </div>
      </div>
    </div>
  </p-card>

  <!-- LOGIN External User -->
  <p-dialog
    header="Login as External User"
    [(visible)]="displayExternalLogin"
    [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
    [style]="{ width: '28rem', maxWidth: '95vw' }"
    styleClass="external-auth-dialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false">
    <div class="p-grid p-fluid external-auth-form">
      <div class="p-col-12">
        <span class="p-float-label">
          <input id="guest-username" type="text" pInputText [(ngModel)]="guestUser.email">
          <label for="guest-username">Email</label>
        </span>
      </div>
      <div class="p-col-12 external-auth-field">
        <label for="guest-login-password" class="external-auth-label">Password</label>
        <p-password id="guest-login-password" [(ngModel)]="guestUser.password" [toggleMask]="true"
          [feedback]="false" [inputStyle]="{ width: '100%' }" styleClass="external-auth-password"></p-password>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="external-auth-dialog-footer">
        <button pButton pRipple type="button" label="Login" class="p-button-outlined" (click)="externalLogin()"></button>
        <button pButton pRipple type="button" label="Cancel" class="p-button-outlined p-button-secondary"
          (click)="cancelExternalDialog()"></button>
      </div>
    </ng-template>
  </p-dialog>

  <!-- Register External User -->
  <p-dialog
    header="Register as External User"
    [(visible)]="displayExternalRegister"
    [breakpoints]="{ '960px': '75vw', '640px': '95vw' }"
    [style]="{ width: '28rem', maxWidth: '95vw' }"
    styleClass="external-auth-dialog"
    [modal]="true"
    [draggable]="false"
    [resizable]="false">
    <div class="p-grid p-fluid external-auth-form">
      <div class="p-col-12">
        <span class="p-float-label">
          <input id="guestUser-email" type="text" pInputText [(ngModel)]="guestUser.email">
          <label for="guestUser-email">Email</label>
        </span>
      </div>
      <div class="p-col-12 external-auth-field">
        <label for="guest-register-password" class="external-auth-label">Password</label>
        <p-password id="guest-register-password" [(ngModel)]="guestUser.password" [toggleMask]="true"
          [feedback]="false" [inputStyle]="{ width: '100%' }" styleClass="external-auth-password"></p-password>
      </div>
      <div class="p-col-12">
        <p-message severity="info" styleClass="w-full"
          text="New accounts are created with read-only access and must be activated by an administrator. If you need additional permissions, ask the administrator to assign you a different role when activating your account. If you need a test account, ask the administrator to set it up as a test user as well."></p-message>
      </div>
    </div>
    <ng-template pTemplate="footer">
      <div class="external-auth-dialog-footer">
        <button pButton pRipple type="button" label="Register" class="p-button-outlined"
          (click)="externalRegister()"></button>
        <button pButton pRipple type="button" label="Cancel" class="p-button-outlined p-button-secondary"
          (click)="cancelExternalDialog()"></button>
      </div>
    </ng-template>
  </p-dialog>
</div>
